import { CALL_API } from '../../middlewares/api';

import {
    REQUEST_EBONS_REMINDER,
    SUCCESS_EBONS_REMINDER,
    FAILURE_EBONS_REMINDER,
    RESET_FORM_SUBMIT_SEND_EBON_REMINDER
} from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

import { makeActionCreator } from '../../utils/actionsUtils';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_SEND_EBON_REMINDER);

export function sendEbonReminder(data, callback) {
    return {
        [CALL_API]: {
            endpoint: '/public/ebon/reminder',
            method: HTTP_METHOD_POST,
            body: data,
            types: [REQUEST_EBONS_REMINDER, SUCCESS_EBONS_REMINDER, FAILURE_EBONS_REMINDER],
            successCallback: () => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/ebonReminder/actions.js